var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M21 6.6h-3.225L15.75 4.5c-.45-.45-1.05-.75-1.65-.75H9.9c-.6 0-1.2.3-1.65.75L6.225 6.6H3C1.725 6.6.75 7.575.75 8.85V18c0 1.275.975 2.25 2.25 2.25h18c1.275 0 2.25-.975 2.25-2.25V8.85c0-1.2-.975-2.25-2.25-2.25m-9 11.25A5.025 5.025 0 1 1 12 7.8a5.025 5.025 0 0 1 0 10.05"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M12 16.35a3.525 3.525 0 1 0 0-7.05 3.525 3.525 0 0 0 0 7.05"
})));
export { SvgCamera2 as ReactComponent };